import { render, staticRenderFns } from "./bulk-payments-processing.vue?vue&type=template&id=00d30d0a&scoped=true"
import script from "./bulk-payments-processing.vue?vue&type=script&lang=js"
export * from "./bulk-payments-processing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d30d0a",
  null
  
)

export default component.exports